import io from 'socket.io-client';
import { checkIdUser, checkAuthentication } from 'utils/authUtils';

// websocket.talasi.codr-staging.id sudah tidak aktif, gunakan server websocket production
const URL = process.env.REACT_APP_SOCKET_URL || 'wss://ws.talasi.com';
const socketOptions = { transports: ['websocket'] };

export const socketCall = io(URL, socketOptions);

// socket untuk chat room yang sedang dibuka
let socket;

// Socket khusus untuk mendengarkan chat masuk ke purchasing admin,
// terpisah dari socket chat room supaya tidak saling menimpa.
// Mengembalikan fungsi untuk memutus koneksi.
export const listenIncomingChat = (callback) => {
  const incomingSocket = io(URL, { ...socketOptions, forceNew: true });
  incomingSocket.on('connect', () => {
    incomingSocket.emit('joinMyChatRoom', {
      current_user_token: checkAuthentication(),
    });
  });
  incomingSocket.on('incoming-chat', (msg) => {
    callback(msg);
  });

  return () => incomingSocket.disconnect();
};

export const initiateSocket = (room, usernameSendUser) => {
  socket = io(URL, { ...socketOptions, forceNew: true });
  socket.on('connect', () => {
    const idUser = parseInt(checkIdUser());

    // Saat terkoneksi maka akan request join room
    socket.emit('joinRoomFarmer', {
      user_id: idUser,
      chat_room_id: parseInt(room),
      name: usernameSendUser,
    });

    // Setelah join room, wajib mengirimkan request empty message
    socket.emit('ChatInit', {
      user_id: idUser,
      chat_room_id: parseInt(room),
      name: usernameSendUser,
      message: '',
    });
  });
};

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
  socket = null;
};

export const subscribeToChat = (cb) => {
  if (!socket) return true;
  socket.on('reply-join', (msg) => {
    return cb(null, msg);
  });
};

export const subscribeToNewChat = (cb) => {
  if (!socket) return true;
  socket.on('reply-chat', (msg) => {
    return cb(null, msg);
  });
};

export const sendMessage = (room, usernameSendUser, message) => {
  if (socket) {
    socket.emit('ChatAdmin', {
      user_id: parseInt(checkIdUser()),
      chat_room_id: parseInt(room),
      name: usernameSendUser,
      message: message.contentMessage,
      offer_id: message.offerId,
      coupon_id: message.couponId,
    });
  }
};
